export default __webpack_public_path__ + "static/media/logo-p.46addb3a.png";